var map = {
	"./Avatar.png": 29170,
	"./Icon-left-1.png": 76064,
	"./Icon-left-2.png": 54395,
	"./Icon-left-3.png": 40178,
	"./Icon-right-1.png": 95097,
	"./Icon-right-2.png": 81090,
	"./Icon-right-3.png": 44747,
	"./RoboEx.png": 67402,
	"./android.png": 37208,
	"./apple.png": 14206,
	"./arrow-right.png": 35287,
	"./benzinga.png": 20879,
	"./bitcoininsider.png": 33209,
	"./blockchaninwire.png": 24844,
	"./blockster.png": 30502,
	"./bloomberg.png": 40714,
	"./check.png": 73237,
	"./coin.png": 97642,
	"./coingetko.png": 10134,
	"./dashboard.png": 29605,
	"./discord.png": 63177,
	"./drive.png": 81785,
	"./facebook.png": 82777,
	"./github.png": 78840,
	"./instagram.png": 86629,
	"./linkedin.png": 86555,
	"./medium.png": 76608,
	"./reddit.png": 2149,
	"./telegram.png": 29404,
	"./theamericanreporter.png": 29841,
	"./threads.png": 80094,
	"./tiktok.png": 19259,
	"./twitter.png": 51708,
	"./website.png": 53846,
	"./yahoo.png": 2633,
	"./youtube.png": 95702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43670;